<template>
  <div class="user-tile has-text-grey-lighter">
    <div v-if="user.profile_picture" class="image is-32x32 mr-4">
      <img :src="user.profile_picture.sm" class="is-rounded" :alt="user.name" />
    </div>

    <div>
      <div>{{ user.name ? user.name : "--" }}</div>

      <div v-if="withEmail">
        <small>{{ user.email }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user", "withEmail"]
};
</script>
